/** Regex to validate 6-digit hex color. */
export const HEX_6_REGEX = /^#[0-9a-fA-F]{6}$/;

/** Default team colors */
export const TEAM_COLOR_HEX_MAP: Record<string, string> = {
  BLACK: "#000000",
  BLUE: "#0000FF",
  BLUE_GREEN: "#008080",
  BROWN: "#A52A2A",
  GREEN: "#008000",
  GREY: "#808080",
  ORANGE: "#FFA500",
  PINK: "#FFC0CB",
  PURPLE: "#800080",
  RED: "#FF0000",
  WHITE: "#FFFFFF",
  YELLOW: "#FFFF00",
} as const;

export const COLOR_FORMATS = {
  HEX: "hex",
  RGB: "rgb",
  HSL: "hsl",
} as const;

export type TColorFormat = (typeof COLOR_FORMATS)[keyof typeof COLOR_FORMATS];

/** Cycle order for format selector: hex → rgb → hsl → hex. */
export const COLOR_FORMAT_ORDERING: Record<TColorFormat, TColorFormat> = {
  [COLOR_FORMATS.HEX]: COLOR_FORMATS.RGB,
  [COLOR_FORMATS.RGB]: COLOR_FORMATS.HSL,
  [COLOR_FORMATS.HSL]: COLOR_FORMATS.HEX,
};

export type TRgbChannel = "r" | "g" | "b";
export type THslChannel = "h" | "s" | "l";

export interface IColorChannelConfig {
  channel: TRgbChannel | THslChannel;
  min: number;
  max: number;
  step: number;
  labelKey: string;
}

export const RGB_CHANNELS: IColorChannelConfig[] = [
  { channel: "r", min: 0, max: 255, step: 1, labelKey: "labels.red" },
  { channel: "g", min: 0, max: 255, step: 1, labelKey: "labels.green" },
  { channel: "b", min: 0, max: 255, step: 1, labelKey: "labels.blue" },
] as const;

export const HSL_CHANNELS: IColorChannelConfig[] = [
  { channel: "h", min: 0, max: 360, step: 1, labelKey: "labels.hue" },
  { channel: "s", min: 0, max: 100, step: 1, labelKey: "labels.saturation" },
  { channel: "l", min: 0, max: 100, step: 1, labelKey: "labels.lightness" },
] as const;
